export default {
  take_update: '/take/update',
};
